/* unplugin-vue-components disabled */import script from "./MemoryNumbers.vue?vue&type=script&setup=true&lang=js"
export * from "./MemoryNumbers.vue?vue&type=script&setup=true&lang=js"

import "./MemoryNumbers.vue?vue&type=style&index=0&id=4a4da040&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a4da040"]])

export default __exports__